import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-cobalt px-4 py-2 text-center" data-id="element-172" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-medium leading-snug text-white sm:text-xs" data-id="element-173" data-mp="1ir7ukifwfhu4">
        <span className="sm:hidden" data-id="element-174" data-mp="1ip55q1qhfuqz">🌍 Disponibile in tutto il mondo · Download immediato</span>
        <span className="hidden sm:inline" data-id="element-175" data-mp="1dq212ieezqjj">
          🌍 Disponibile in tutto il mondo · Download immediato · Pensato per i docenti di chimica
        </span>
      </p>
    </div>;
}